import { useEffect, useState } from "react";
import _ from "lodash";
import { loggedInUser } from "../helpers/common";
import { USER_TYPE_AGENT } from "../constants/common";
import { convertToNumber } from "../helpers/validations";

const usePremiumUser = () => {
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [shouldToggleColor, setShouldToggleColor] = useState(false);

  useEffect(() => {
    const user = loggedInUser();
    const userInfo = _.get(user, "userInfo", null);
    const _usertype = parseInt(_.get(userInfo, "userType", null));
    const premium = convertToNumber(_usertype) === USER_TYPE_AGENT;

    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0].toLowerCase();

    setIsPremiumUser(premium);
    setShouldToggleColor(
      (premium || subdomain === "cove" || subdomain === "mls" || subdomain === "mibormembers") &&
        subdomain !== "stellar" &&
        subdomain !== "test-mls" &&
        subdomain !== "bls" &&
        subdomain !== "lar",
    );
  }, []);

  return { isPremiumUser, shouldToggleColor };
};

export default usePremiumUser;
